import { render } from "./rich-content.vue?vue&type=template&id=85beb642"
import script from "./rich-content.vue?vue&type=script&lang=js"
export * from "./rich-content.vue?vue&type=script&lang=js"

import "./rich-content.vue?vue&type=style&index=0&id=85beb642&lang=scss"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__